/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_Faq_Q2Inputs */

const en_guide_json_schema_faq_q2 = /** @type {(inputs: Guide_Json_Schema_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What tools validate JSON against a schema?`)
};

const ko_guide_json_schema_faq_q2 = /** @type {(inputs: Guide_Json_Schema_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON을 스키마에 대해 검증하는 도구는 무엇이 있나요?`)
};

const ja_guide_json_schema_faq_q2 = /** @type {(inputs: Guide_Json_Schema_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONをスキーマに対して検証するツールは？`)
};

/**
* | output |
* | --- |
* | "What tools validate JSON against a schema?" |
*
* @param {Guide_Json_Schema_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_faq_q2 = /** @type {((inputs?: Guide_Json_Schema_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_faq_q2(inputs)
	if (locale === "ko") return ko_guide_json_schema_faq_q2(inputs)
	return ja_guide_json_schema_faq_q2(inputs)
});